import BaseComponent from "@js/components/base_component.jsx";
import EuiDnsStatusPanel from "@js/components/eui/dns_status_panel.jsx";

class EuiReceivingDomainsForm extends BaseComponent {

  static defaultProps = {
    editing: true,
  };

  render() {
    const rd = this.props.receiving_domain;
    const isNew = !rd.persisted;

    return (
      <div>

        <ErrorBanner entity={ rd } />

        <Panel heading="receiving_domain_settings">
          <div className="form-horizontal">

            <InputField
              object={ rd }
              type="receiving_domain"
              field="domain"
              editing={ this.props.editing && isNew }
              helpRawHtml={ I18n.t("simple_form.hints.receiving_domain.domain_html") }
            />

            { isNew ? (
              <SelectField
                field="receiving_domain.cname_suffix_domain"
                blank={ null }
                value={ rd.cname_suffix_domain }
                options={ this._cnameSuffixDomainOptions() }
                editing={ true }
                error={ rd.errors ? rd.errors.cname_suffix_domain : null }
                helpRawHtml={ I18n.t("simple_form.hints.receiving_domain.cname_suffix_domain_html") }
              />
            ) : (
              <FieldContainer
                labelText={ I18n.t("simple_form.labels.receiving_domain.cname_suffix_domain") }
                helpRawHtml={ I18n.t("simple_form.hints.receiving_domain.cname_suffix_domain_html") }
              >
                { rd.cname_suffix_domain }
              </FieldContainer>
            )}

            { !isNew && rd.incoming_email_domain_id && (
              <FieldContainer labelText={ I18n.t("simple_form.labels.receiving_domain.incoming_email_domain_id") }>
                <a href={ Routes.eui_incoming_email_domain_path(rd.incoming_email_domain_id) }>
                  { rd.domain }
                </a>
              </FieldContainer>
            )}

            { !isNew && !rd.dns_verified && (
              <div className="form-group">
                <div className="col-sm-offset-4 col-sm-8">
                  <span className="text-muted">{ I18n.t("phrases.receiving_domain_dns_pending") }</span>
                </div>
              </div>
            )}

          </div>
        </Panel>

        { !this.props.editing && (
          <EuiDnsStatusPanel
            domain={ rd.domain }
            dns_verified={ rd.dns_verified }
            dns_verified_time_pretty={ rd.dns_verified_time_pretty }
            dns_regression={ rd.dns_regression }
            dns_regression_time_pretty={ rd.dns_regression_time_pretty }
            wanted_dns_records={ rd.wanted_dns_records }
            unwanted_dns_records={ rd.unwanted_dns_records }
          />
        )}

      </div>
    );
  }

  _cnameSuffixDomainOptions() {
    return (this.props.allowed_cname_suffix_domains || []).map(function(d) {
      return { value: d, label: d };
    });
  }

}

export default EuiReceivingDomainsForm;
